import { Controller } from "react-hook-form";
import { ISelectOptions } from "../../../types/inputs";
import { Button } from "../../Atoms/Button";
import { Input } from "../../Atoms/Inputs/Input";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useDispatcherCustomerRegister } from "./useDispatcherCustomerRegister";
import { MessageErroForm } from "../../Atoms/MessageErroForm";

export const DispatcherCustomerRegisterTemplate = () => {
  const {
    navigate,
    cidadesOptions,
    control,
    errors,
    handleSubmit,
    register,
    submteForm,
    ufOptions,
    handleCep,
  } = useDispatcherCustomerRegister();
  return (
    <S.Container>
      <Title>Cadastro de Cliente</Title>

      <S.FormModal onSubmit={handleSubmit(submteForm)}>
        <S.GridModal>
          <div>
            <Input {...register("nome")} id="name" label="Nome" required />
            {errors?.nome && (
              <MessageErroForm>{errors?.nome?.message}</MessageErroForm>
            )}
          </div>
          <div>
            <Input
              {...register("cpfCnpj")}
              id="cpf"
              label="CPF/CNPJ"
              required
              maxLength={18}
            />

            {errors?.cpfCnpj && (
              <MessageErroForm>{errors?.cpfCnpj?.message}</MessageErroForm>
            )}
          </div>
          <div>
            <Input
              {...register("email")}
              id="email"
              label="E-mail"
              type="email"
            />
            {errors?.email && (
              <MessageErroForm>{errors?.email?.message}</MessageErroForm>
            )}
          </div>
          <div>
            <Input
              {...register("telefone")}
              id="telefone"
              required
              label="Telefone"
              maxLength={15}
            />
            {errors?.telefone && (
              <MessageErroForm>{errors?.telefone?.message}</MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("endereco.cep")}
              id="cep"
              required
              label="Cep"
              maxLength={9}
              onBlur={handleCep}
            />

            {errors?.endereco?.cep && (
              <MessageErroForm>
                {errors?.endereco?.cep?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("endereco.logradouro")}
              id="rua"
              label="Endereço (Rua)"
              required
            />

            {errors?.endereco?.logradouro && (
              <MessageErroForm>
                {errors?.endereco?.logradouro?.message}
              </MessageErroForm>
            )}
          </div>
          <div>
            <Input
              {...register("endereco.numero")}
              id="numero"
              label="Numero"
              type="number"
              required
            />

            {errors?.endereco?.numero && (
              <MessageErroForm>
                {errors?.endereco?.numero?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("endereco.bairro")}
              id="bairro"
              label="Bairro"
              required
            />

            {errors?.endereco?.bairro && (
              <MessageErroForm>
                {errors?.endereco?.bairro?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Input
              {...register("endereco.complemento")}
              id="complemento"
              label="Complemento"
            />

            {errors?.endereco?.complemento && (
              <MessageErroForm>
                {errors?.endereco?.complemento?.message}
              </MessageErroForm>
            )}
          </div>

          <div>
            <Controller
              name="endereco.uf"
              control={control}
              render={({ field: { onChange, value } }) => (
                <SimpleSelect
                  label="UF"
                  required
                  key={`${Math.random()}`}
                  value={ufOptions.find((_) => _?.value === value)}
                  options={ufOptions}
                  onChange={(e: ISelectOptions) =>
                    e ? onChange(e?.value) : onChange("")
                  }
                />
              )}
            />

            {errors?.endereco?.uf && (
              <MessageErroForm>{errors?.endereco?.uf?.message}</MessageErroForm>
            )}
          </div>
          <div>
            <Controller
              control={control}
              name="endereco.cidade"
              render={({ field: { onChange, value } }) => (
                <SimpleSelect
                  label="Cidade"
                  required
                  key={`${Math.random()}`}
                  value={cidadesOptions.find((_) => _?.value === value)}
                  options={cidadesOptions}
                  onChange={(e: ISelectOptions) =>
                    e ? onChange(e?.value) : onChange("")
                  }
                />
              )}
            />

            {errors?.endereco?.cidade && (
              <MessageErroForm>
                {errors?.endereco?.cidade?.message}
              </MessageErroForm>
            )}
          </div>
          <div className="wrapperButtons">
            <Button
              data-variant-text
              type="button"
              onClick={() => navigate(-1)}
            >
              Voltar
            </Button>
            <Button>Cadastrar</Button>
          </div>
        </S.GridModal>
      </S.FormModal>
    </S.Container>
  );
};
